import { gql } from '@apollo/client';

// export const FETCH_ALL_GROUPS = gql`
//     query FetchAllGroups {
//         fetchAllGroups {
//             data {
//                 groups {
//                     folder_id
//                     id
//                     name
//                 }
//             }
//             error {
//                 message
//             }
//         }
//     }

// `;

export const FETCH_ALL_GROUPS = gql`
  query FetchAllGroups {
    fetchAllGroups {
        data {
            groups {
                name
                folder_id
                description
                image
                icon
                updated_at
                group_order
                id
                created_at
                button_name
                eligibility
            }
        }
        error {
            field
            message
            code
        }
    }
}

`;


